import styled from "styled-components";

export const SectionDivider = styled.div`
    width: 100px;
    height: 6px;
    border-radius: 10px;
    background-color: #fff;
    background: ${(props) => props.colorAlt ? 
        'linear-gradient(270deg, #F46737 0%, #945DD6 100%)' :
        'linear-gradient(270deg, #13ADC7 0%, #945DD6 100%)'};

        margin: ${(props) => props.divider ? "4rem 0" : "" };
`;

export const Container = styled.div`
    width: 90%;
    margin: 0 auto;
`;

export const SkillsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    @media ${(props) => 'screen and (max-width: 1280px)'} {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        gap: 0.5rem;
    }
`;

export const SkillsSubContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
`;

export const Skills = styled.section`
    display: flex;
    justify-content: flex-start; 
    align-items: center;
    color: white;
    margin-bottom: 20px;
    margin-left: 10px;
`;

export const Title = styled.h2`
    color: white;
    font-weight: 800;
    font-size: 65px;
    margin-bottom: 10px;
    text-align: left;
    @media ${(props) => 'screen and (max-width: 900px)'} {
        font-size: 48px;
        font-weight: 600;
    }
`;

export const BodyTitleContainer = styled.div`
    margin: auto;
`;

export const BodyTitle = styled.p`
    color: white;
    font-size: 24px;
    font-weight: 700;
    margin: auto;
    padding: 1rem;
    text-align: left;
    @media ${(props) => 'screen and (max-width: 900px)'} {
        font-size: 20px;
        font-weight: 600;
    }
`;

export const Span = styled.span`
    font-size: 22px;
    padding-left: 1rem;
    text-align: left;
    @media ${(props) => 'screen and (max-width: 700px)'} {
        font-size: 16px;
        padding-left: 0.5rem;
    }
`;

export const Body = styled.p`
    color: rgba(255, 255, 255, 0.5);
    font-size: 22px;
    margin: auto;
    margin-bottom: 20px;
    padding: 1rem;
    text-align: justify;
    @media ${(props) => 'screen and (max-width: 900px)'} {
        font-size: 18px;
    }
`;

export const ImageWrapper = styled.div`
    font-size: 2rem;
    @media ${(props) => 'screen and (max-width: 700px)'} {
        font-size: 1.5rem;
    }
`;